import { render, staticRenderFns } from "./OperateLabel.vue?vue&type=template&id=5dda6905"
import script from "./OperateLabel.vue?vue&type=script&lang=js"
export * from "./OperateLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports